import React, { Component, PropTypes } from 'react';
import { Snackbar } from 'material-ui';
import { MessageActions } from 'actions';

class AppSnackBar extends Component {
  static displayName = 'AppSnackBar';

  static propTypes = {
    message: PropTypes.string,
    type: PropTypes.string,
    translate: PropTypes.bool
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.message !== nextProps.message &&
      nextProps.message &&
      nextProps.message !== ''
    ) {
      this.refs.snackbar.show();
    }
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps.message || nextProps.message === this.props.message) {
      return false;
    }
    return true;
  }

  reset() {
    MessageActions.clearMessage();
  }

  render() {
    const { message, translate } = this.props;
    const messageText = translate
      ? this.context.getIntlMessage(message)
      : message;
    return (
      <Snackbar
        Snackbar
        autoHideDuration={3000}
        style={{ fontSize: '12px', lineHeight: 1.5, padding: 10 }}
        ref="snackbar"
        message={messageText || ''}
        onDismiss={::this.reset}
      />
    );
  }
}

export default AppSnackBar;



// WEBPACK FOOTER //
// ./src/js/components/AppSnackBar.js